import { api } from '@/utils/api';

export default class SimulationsRepository {
	async getRecommendedStrategies({
		startDate,
		endDate,
		locationId,
	}: {
		startDate: string;
		endDate: string;
		locationId: string;
	}) {
		try {
			const response = await api.get(`simulations/recommended-strategies`, {
				params: {
					startDate,
					endDate,
					locationId,
				},
			});
			return response.data;
		} catch (error) {
			console.error(error);
		}
	}
}
